import { ChangeDetectionStrategy,Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTab,MatTabGroup } from '@angular/material/tabs';
import { ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';

import { AdminComponentBase } from 'app/layout/content/admin-component-base';
import { PageSimpleContentComponent } from 'app/layout/content/page-simple-content.component';
import { Store, StoreLogUnion } from 'app/shared/graph';

import { StoreLogsService } from './store-logs.service';
import { StoreLogsGroupComponent } from './store-logs-group.component';

export interface GroupedLogs {
    timestampUtc: string;
    storeLogs: StoreLogUnion[];
}

@Component({
    templateUrl: './store-logs-page.component.html',
    styleUrls: ['./store-logs-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [PageSimpleContentComponent, MatTabGroup, MatTab, StoreLogsGroupComponent, MatIcon]
})
export class StoreLogsPageComponent extends AdminComponentBase implements OnInit, OnDestroy {
    private readonly route = inject(ActivatedRoute);
    private readonly storeLogsService = inject(StoreLogsService);

    storeId: string;
    hubStoreLogs: GroupedLogs[] = [];
    shopifyStoreLogs: GroupedLogs[] = [];
    store: Store;

    ngOnInit(): void {
        this.registerSubscription(this.route.params.subscribe(params => {
            this.storeId = params.storeId;
            this.subscribeWithGenericLoadingErrorHandling(forkJoin([
                this.storeLogsService.getHubStoreLogs(this.storeId),
                this.storeLogsService.getShopifyStoreLogs(this.storeId)
            ]), ([hubStoreLogs, shopifyStoreLogs]) => {
                this.hubStoreLogs = this.groupLogsByDay(hubStoreLogs);
                this.shopifyStoreLogs = this.groupLogsByDay(shopifyStoreLogs);
            })
        }));
    }

    groupLogsByDay(storeLogs: StoreLogUnion[]) {
        const timestamp = new Map<string, StoreLogUnion[]>();

        for (let storeLog of storeLogs) {
            const group = timestamp.get(storeLog.timestampUtc) || [];
            group.push(storeLog);
            timestamp.set(storeLog.timestampUtc, group);
        }

        return [...timestamp.entries()].map(([timestampUtc, storeLogs]) => ({
            timestampUtc,
            storeLogs
        }));
    }

    ngOnDestroy() {
        this.unsubscribeSubscriptions();
    }
}
